// extracted by mini-css-extract-plugin
module.exports = {"hotel":"Hotel_hotel__1_Bob"};